import get from 'lodash/fp/get'
import at from 'lodash/fp/at'
import { call, put } from 'redux-saga/effects'
import { createRoutineSaga, SAGA_WATCHER_LATEST_MODE } from '../../utils/saga'
import injectSaga from '../../state/hoc/injectSaga'

import { recoverPasswordRoutine, resetPasswordRoutine } from './routines'
import api from './api'
import { setToken } from '../Login/actions'

// callers
export function * recoverPasswordSaga(data) {
  const result = yield call(api.recovery, data)

  return result
}

export function * resetPasswordSaga(token, data) {
  const result = yield call(api.reset, token, data)

  return result
}

export function * onResetPasswordSuccess(token) {
  yield put(setToken(token))
}

// watchers
export const { watcher: recoverPasswordWatcher } = createRoutineSaga({
  routine: recoverPasswordRoutine,
  requestSaga: recoverPasswordSaga,
  requestArgsCreator: get('payload'),
  watcherMode: SAGA_WATCHER_LATEST_MODE
})

export const { watcher: resetPasswordWatcher } = createRoutineSaga({
  routine: resetPasswordRoutine,
  requestSaga: resetPasswordSaga,
  requestArgsCreator: at(['payload.token', 'payload']),
  onSuccessSaga: onResetPasswordSuccess,
  watcherMode: SAGA_WATCHER_LATEST_MODE
})

// injectors
export const withRecoverPasswordSaga = injectSaga({
  key: 'password/recovery',
  saga: recoverPasswordWatcher
})

export const withResetPasswordSaga = injectSaga({
  key: 'password/reset',
  saga: resetPasswordWatcher
})
